import React from "react";
import { NavButton } from "./NavButton.tsx";

export const SelectVenuesButton = () => {
  return (
    <NavButton
      label={"Find Films Near You"}
      ariaLabel={"plan next cinema trip"}
      to={"/cinema-select"}
      boxSx={{ pb: { xs: 0, md: 3 } }}
      buttonSx={{ fontSize: { xs: "x-large" } }}
    />
  );
};
